<template>
  <div>
    <div class="one-step" v-show="step === 1">
      <div class="layer">
        <div class="tip" v-text="$t('create_plan.target_title')"></div>
        <div class="layer-items-content">
          <div :class="'layer-items' + (item.index === form.target ? ' select-item' : '')" v-for="(item, index) in target" :key="index" @click="form.target = item.index">
            <div class="layer-icon"><i :class="item.icon"></i></div>
            <div class="layer-title" v-text="item.title"></div>
          </div>
        </div>
      </div>

      <div class="layer" v-show="form.target !== ''">
        <div class="tip" v-text="$t('create_plan.plan_title')"></div>
        <div class="layer-items-content">
          <div :class="'layer-items' + (item.index === form.plan_type ? ' select-item' : '')" v-for="(item, index) in plan_type" :key="index" @click="form.plan_type = item.index">
            <div class="title" v-text="item.title"></div>
            <div class="img"><img :src="item.img"></div>
            <div class="desc" v-text="item.desc"></div>
          </div>
          <div class="layer-items" style="border: none;"></div>
          <div class="layer-items" style="border: none;"></div>
        </div>
      </div>

      <div class="layer" v-show="form.plan_type !== ''">
        <div class="tip" v-text="$t('create_plan.type_title')"></div>
        <div class="checkbox">
          <div class="check-item"><el-radio v-model="form.target_type" label="1">{{ $t('create_plan.type1') }}</el-radio></div>
          <div class="check-item"><el-radio v-model="form.target_type" label="2">{{ $t('create_plan.type2') }}</el-radio></div>
          <div class="check-item"><el-radio v-model="form.target_type" label="3">{{ $t('create_plan.type3') }}</el-radio></div>
        </div>
      </div>
      <div class="btn">
        <el-button type="primary" size="small" @click="next" v-text="$t('adv_common.next')"></el-button>
        <el-button type="text" @click="cancel" v-text="$t('common.layer_btn_cancel')"></el-button>
      </div>
    </div>

    <div class="two-step" v-show="step === 2">
      <div style="height: 70px;"></div>
      <div class="step-layer">
        <div class="step">
          <div class="step-item current">
            <div class="step-icon">1</div>
            <div class="step-title" v-text="$t('adv_common.first')"></div>
          </div>
          <div class="step-line"></div>
          <div class="step-item">
            <div class="step-icon">2</div>
            <div class="step-title" v-text="$t('adv_common.second')"></div>
          </div>
          <div class="step-line"></div>
          <div class="step-item">
            <div class="step-icon">3</div>
            <div class="step-title" v-text="$t('adv_common.third')"></div>
          </div>
        </div>
      </div>

      <div class="btn" v-text="$t('create_plan.default_set')"></div>
      <div class="layer">
        <div class="one-line">
          <span class="title" v-text="$t('create_plan.type')"></span>{{ plan_type[form.plan_type - 1] !== undefined ? plan_type[form.plan_type - 1].title : '' }}
          <span class="title" style="margin-left: 30px;" v-text="$t('create_plan.target')"></span>{{ target[form.target - 1] !== undefined ? target[form.target - 1].title : '' }}
        </div>
      </div>

      <div class="layer">
        <div class="input">
          <div class="left-title" v-text="$t('create_plan.title')"></div>
          <div class="right-content"><el-input v-model="form.title" size="small" style="width: 220px" :placeholder="$t('create_plan.title_p')"></el-input></div>
        </div>
      </div>

      <div class="layer">
        <div class="input">
          <div class="left-title" v-text="$t('create_plan.network')"></div>
          <div class="right-content">
            <div class="select-type">
              <div class="left-img"><img :src="plan_type[form.plan_type - 1] !== undefined ? plan_type[form.plan_type - 1].img : ''"></div>
              <div class="right-body">
                <div class="title">{{ plan_type[form.plan_type - 1] !== undefined ? plan_type[form.plan_type - 1].title : '' }}</div>
                <div class="content">{{ plan_type[form.plan_type - 1] !== undefined ? plan_type[form.plan_type - 1].desc : '' }}</div>
                <div class="desc" v-text="$t('create_plan.network_desc')"></div>
              </div>
            </div>
            <div class="select-type">
              <div class="left-img"><img src="../../../assets/images/plan/1.png"></div>
              <div class="right-body">
                <div class="title" v-text="$t('create_plan.network_title')"></div>
                <div class="content" v-text="$t('create_plan.network_content')"></div>
                <div class="desc" v-text="$t('create_plan.network_desc')"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="layer">
        <div class="input">
          <div class="left-title" v-text="$t('create_plan.date')"></div>
          <div class="right-content">
            <div class="date">
              <div class="date-title" v-text="$t('create_plan.date_s')"></div>
              <div><el-date-picker v-model="form.start_time" value-format="yyyy-MM-dd" type="date" size="small" :placeholder="$t('create_plan.date_p')"></el-date-picker></div>
            </div>
            <div class="date">
              <div class="date-title" v-text="$t('create_plan.date_e')"></div>
              <!-- <div style="margin-bottom: 5px;"><el-radio v-model="form.is_end_time" label="1">无</el-radio></div> -->
              <div><el-date-picker v-model="form.end_time" value-format="yyyy-MM-dd" type="date" size="small" :placeholder="$t('create_plan.date_p')"></el-date-picker></el-radio></div>
            </div>
            <div class="right-data-font">
              <div class="" v-text="$t('create_plan.date_desc1')"></div>
              <div class="" v-text="$t('create_plan.date_desc2')"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="layer">
        <div class="input">
          <div class="left-title" v-text="$t('create_plan.set_title')"></div>
          <div class="right-content">
            <div class="date">
              <div class="date-title" v-text="$t('create_plan.set_title1')"></div>
              <div><el-input v-model="form.name" :placeholder="$t('create_plan.set_title_p')" style="width: 250px;" size="small"></el-input></div>
            </div>
            <div class="date">
              <div class="date-title" v-text="$t('create_plan.set_desc')"></div>
              <div>
                <el-select v-model="form.language" :placeholder="$t('create_plan.set_options')" size="small">
                  <el-option :label="item.label" :value="item.value" v-for="(item, index) in options" :key="index"></el-option>
                </el-select></div>
              </div>
            <div class="date">
              <div class="date-title" v-text="$t('create_plan.set_position')"></div>
              <div style="margin-bottom: 5px; margin-top: 10px;"><el-radio v-model="form.source" label="1">{{ $t('create_plan.set_options1') }}</el-radio></div>
              <div style="margin-bottom: 5px;"><el-radio v-model="form.source" label="2">{{ $t('create_plan.set_options2') }}</el-radio></div>
              <div style="margin-bottom: 5px;"><el-radio v-model="form.source" label="3">{{ $t('create_plan.set_options3') }}</el-radio></div>
            </div>
            <div class="right-data-font" style="height: 100%;">
              <div class="" v-text="$t('create_plan.font')"></div>
              <div v-text="$t('create_plan.font_content1')"></div>
              <div v-text="$t('create_plan.font_content2')"></div>
              <div v-text="$t('create_plan.font_content3')"></div>
              <div v-text="$t('create_plan.font_content4')"></div>
              <div v-text="$t('create_plan.font_content5')"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="layer">
        <div class="input">
          <div class="left-title" v-text="$t('create_plan.time')"></div>
          <div class="right-content" v-text="$t('create_plan.time_content')"></div>
        </div>
      </div>

      <!-- <div class="btn" style="margin-top: 70px;" v-text="$t('create_plan.position_title')"><br /><span style="font-size: 13px;" v-text="$t('create_plan.position_title2')"></span></div> -->
      <!-- <div class="layer">
        <div class="input">
          <div class="left-title" v-text="$t('create_plan.position')"></div>
          <div class="right-content">
            <div class="date">
              <div class="date-title" v-text="$t('create_plan.position_desc')"></div>
              <div style="margin-bottom: 5px; margin-top: 10px;"><el-radio v-model="form.location" label="1">{{ $t('create_plan.country') }}</el-radio></div>
              <div style="margin-bottom: 5px;"><el-radio v-model="form.location" label="2">{{ $t('create_plan.china') }}</el-radio></div>
              <div style="margin-bottom: 5px;"><el-radio v-model="form.location" label="3">{{ $t('create_plan.other') }}</el-radio></div>
              <div style="padding-left: 25px;"><el-input v-model="form.other_location" :placeholder="$t('create_plan.other_p')" style="width: 250px;" size="small" v-show="form.location === '3'"></el-input></div>
              <div style="color: rgba(0,0,0,.54); font-size: 12px; margin-top: 5px; padding-left: 25px;" v-show="form.location === '3'" v-text="$t('create_plan.other_desc')"></div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- <div class="layer">
        <div class="input">
          <div class="left-title" v-text="$t('create_plan.languare')"></div>
          <div class="right-content">
            <div class="date" style="width: 45%;">
              <div class="date-title" v-text="$t('create_plan.languare_title')"></div>
              <div class="date-title" v-text="$t('create_plan.languare_title2')"></div>
              <div><el-cascader :placeholder="$t('create_plan.languare_p')" v-model="form.language_str" size="small" :options="options" :props="{ multiple: true }" filterable style="width: 100%;"></el-cascader></div>
            </div>
            <div class="right-data-font" style="height: 100%;">
              <div v-html="$t('create_plan.languare_desc1')"></div>
              <div v-html="$t('create_plan.languare_desc2')"></div>
            </div>
          </div>
        </div>
      </div> -->

      <div class="btn" style="margin-top: 70px;">{{ $t('create_plan.price1') }}<br /><span style="font-size: 13px;" v-text="$t('create_plan.price2')"></span></div>
      <div class="layer">
        <div class="input">
          <div class="left-title" v-text="$t('create_plan.price_title')"></div>
          <div class="right-content">
            <div class="date" style="width: 45%;">
              <div class="date-title" v-text="$t('create_plan.price_title2')"></div>
              <div><el-input v-model="form.budget" type="number" size="small" style="width: 220px" :placeholder="$t('create_plan.price_title_p')"></el-input></div>
            </div>
            <div class="date" style="width: 45%;">
              <div class="date-title" v-text="$t('create_plan.group_price')"></div>
              <div><el-input v-model="form.group_price" size="small" style="width: 220px" :placeholder="$t('create_plan.group_price_p')"></el-input></div>
            </div>
            <div class="right-data-font" style="height: 100%;">
              <div v-html="$t('create_plan.price_desc1')"></div>
              <div v-html="$t('create_plan.price_desc2')"></div>
              <div v-html="$t('create_plan.price_desc3')"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="layer">
        <div class="input">
          <div class="left-title" v-text="$t('create_plan.pay')"></div>
          <div class="right-content">
            <div class="date" style="width: 45%;">
              <div class="date-title" v-text="$t('create_plan.pay_title')"></div>
              <div>
                <el-select v-model="form.price_type" :placeholder="$t('create_plan.set_options')" size="small">
                  <el-option :label="item.label" :value="item.value" v-for="(item, index) in price_type" :key="index"></el-option>
                </el-select>
              </div>
              <div style="color: rgba(0,0,0,.54); font-size: 12px; margin-top: 5px;" v-text="$t('create_plan.pay_desc')"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="layer">
        <div class="input">
          <div class="left-title" v-text="$t('create_plan.num')"></div>
          <div class="right-content">
            <div class="date" style="width: 45%;">
              <div class="date-title" v-text="$t('create_plan.num_title')"></div>
              <div>
                <div style="margin-bottom: 5px;"><el-radio v-model="form.number" label="1">{{ $t('create_plan.num_option1') }}</el-radio></div>
                <div style="margin-bottom: 5px;"><el-radio v-model="form.number" label="2">{{ $t('create_plan.num_option2') }}</el-radio></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="layer">
        <div class="input">
          <div class="left-title" v-text="$t('create_plan.banner')"></div>
          <div class="right-content">
            <div class="date" style="width: 45%;">
              <div>
                <div style="margin-bottom: 5px;"><el-radio v-model="form.show_type" label="1">{{ $t('create_plan.banner1') }}</el-radio></div>
                <div style="margin-bottom: 5px;"><el-radio v-model="form.show_type" label="2">{{ $t('create_plan.banner2') }}</el-radio></div>
                <!-- <div style="margin-bottom: 5px;"><el-radio v-model="form.show_type" label="3">{{ $t('create_plan.banner3') }}</el-radio></div> -->
                <!-- <div style="margin-bottom: 5px;"><el-radio v-model="form.show_type" label="4">{{ $t('create_plan.banner4') }}</el-radio></div> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="btn">
        <el-button type="primary" size="small" @click="save" v-text="$t('adv_common.save_btn1')"></el-button>
      </div>
    </div>
    <div style="height: 100px;"></div>
  </div>

</template>

<script>
export default {
  name: 'createPlan',
  props: ['plan_data'],
  data() {
    return {
      step: 1,
      checked: false,
      active: 0,
      form: {
        plan_id: '',
        target: '',
        plan_type: '',
        target_type: '',
        title: '',
        start_time: '',
        end_time: '',
        is_end_time: '',
        name: '',
        language: '',
        source: '',
        location: '',
        language_str: [],
        budget: '',
        group_price: '',
        price_type: '',
        number: '',
        show_type: ''
      },
      options: [
        { value: '1', label: this.$t('languare.a1') },
        { value: '2', label: this.$t('languare.a2') },
        { value: '3', label: this.$t('languare.a3') },
        { value: '4', label: this.$t('languare.a4') },
        { value: '5', label: this.$t('languare.a5') },
        { value: '6', label: this.$t('languare.a6') },
        { value: '7', label: this.$t('languare.a7') },
        { value: '8', label: this.$t('languare.a8') },
        { value: '9', label: this.$t('languare.a9') },
        { value: '10', label: this.$t('languare.a10') },
        { value: '11', label: this.$t('languare.a11') },
        { value: '12', label: this.$t('languare.a12') },
        { value: '13', label: this.$t('languare.a13') },
        { value: '14', label: this.$t('languare.a14') },
        { value: '15', label: this.$t('languare.a15') },
        { value: '16', label: this.$t('languare.a16') },
        { value: '17', label: this.$t('languare.a17') },
        { value: '18', label: this.$t('languare.a18') },
        { value: '19', label: this.$t('languare.a19') },
        { value: '20', label: this.$t('languare.a20') },
        { value: '21', label: this.$t('languare.a21') },
        { value: '22', label: this.$t('languare.a22') },
        { value: '23', label: this.$t('languare.a23') },
        { value: '24', label: this.$t('languare.a24') },
        { value: '25', label: this.$t('languare.a25') },
        { value: '26', label: this.$t('languare.a26') },
        { value: '27', label: this.$t('languare.a27') },
        { value: '28', label: this.$t('languare.a28') },
        { value: '29', label: this.$t('languare.a29') },
        { value: '30', label: this.$t('languare.a30') }
      ],
      target: [
        { index: 1, icon: 'fa fa-tag', title: this.$t('create_plan.target1') },
        { index: 2, icon: 'fa fa-user', title: this.$t('create_plan.target2') },
        { index: 3, icon: 'fa fa-paper-plane-o', title: this.$t('create_plan.target3') },
        { index: 4, icon: 'fa fa-heart ', title: this.$t('create_plan.target4') },
        { index: 5, icon: 'fa fa-bullhorn', title: this.$t('create_plan.target5') },
        { index: 6, icon: 'fa fa-mobile', title: this.$t('create_plan.target6') },
        { index: 7, icon: 'fa fa-map-marker', title: this.$t('create_plan.target7') },
        { index: 8, icon: 'fa fa-cog', title: this.$t('create_plan.target8') }
      ],
      price_type: [
        { value: 1, label: this.$t('create_plan.price_type1') },
        { value: 2, label: this.$t('create_plan.price_type2') },
        { value: 3, label: this.$t('create_plan.price_type3') },
        { value: 4, label: this.$t('create_plan.price_type4') },
        { value: 5, label: this.$t('create_plan.price_type5') },
        { value: 6, label: this.$t('create_plan.price_type6') }
      ],
      plan_type: [
        { index: 1, desc: this.$t('create_plan.plan1'), title: this.$t('adv.search'), img: require('../../../assets/images/plan/1.png') },
        { index: 2, desc: this.$t('create_plan.plan2'), title: this.$t('adv.show'), img: require('../../../assets/images/plan/2.png') },
        { index: 3, desc: this.$t('create_plan.plan3'), title: this.$t('adv.shopping'), img: require('../../../assets/images/plan/3.png') }
        // { index: 4, desc: this.$t('create_plan.plan4'), title: this.$t('adv.video'), img: require('../../../assets/images/plan/4.png') },
        // { index: 5, desc: this.$t('create_plan.plan5'), title: this.$t('adv.ai'), img: require('../../../assets/images/plan/5.png') },
        // { index: 6, desc: this.$t('create_plan.plan6'), title: this.$t('adv.find'), img: require('../../../assets/images/plan/6.png') }
      ],
      type: 'add'
    };
  },
  created() {
    // 编辑
    let title = this.$t('create_adv.create');
    if (this.plan_data.plan_id !== undefined && parseInt(this.plan_data.plan_id) > 0) {
      this.form = {
        plan_id: this.plan_data.plan_id,
        target: this.plan_data.target,
        plan_type: this.plan_data.plan_type,
        target_type: this.plan_data.target_type,
        title: this.plan_data.title,
        start_time: this.plan_data.start_time,
        end_time: this.plan_data.end_time,
        name: this.plan_data.name,
        language: parseInt(this.plan_data.language) > 0 ? this.plan_data.language + '' : '',
        source: this.plan_data.source + '',
        location: this.plan_data.location + '',
        language_str: this.plan_data.language_str,
        budget: this.plan_data.budget,
        group_price: this.plan_data.group_price,
        price_type: parseInt(this.plan_data.price_type) > 0 ? parseInt(this.plan_data.price_type) : '',
        number: this.plan_data.number + '',
        show_type: this.plan_data.show_type + ''
      };
      this.step = 2;
      this.type = 'edit';
      title = this.$t('create_adv.edit');
    }
    document.title = `${title}` + this.$t('create_plan.plan_desc');
    this.$function.hiddenLoading();
  },
  methods: {
    next() {
      if (this.form.target === '') {
        this.$message.error(this.$t('create_plan.target_verify'));
        return false;
      }
      if (this.form.plan_type === '') {
        this.$message.error(this.$t('create_plan.type_verify'));
        return false;
      }
      const layout_right = document.querySelector('.layout-right');
      if (layout_right) {
        layout_right.scrollTo(0, 0);
      }
      this.step += 1;
    },
    save() {
      if (this.form.title === '') {
        this.$message.error(this.$t('create_plan.title_verify'));
        return false;
      }
      if (this.form.budget === '') {
        this.$message.error(this.$t('create_plan.budget_verify'));
        return false;
      }
      if (parseFloat(this.form.group_price) <= 0) {
        this.$message.error(this.$t('create_plan.group_price_verify'));
        return false;
      }

      const url = this.type === 'add' ? '/trader/index/createPlan' : '/trader/index/savePlan';
      this.$http.post(url, this.form).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('create_plan.success'));
          if (this.type === 'add') {
            this.$emit('plan_call_back', res.plan_id);
          } else {
            this.cancel();
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    cancel() {
      this.$emit('jump_adv', 'PlanView');
    }
  }
};
</script>

<style lang="less" scoped="">
  .btn {
    width: 1088px;
    margin: 40px auto;
    font-size: 15px;
    color: #222;
  }
  .layer {
    width: 1024px;
    padding: 24px 32px;
    margin: 30px auto;
    background: #fff;
    font-size: 14px;
    box-shadow: 0 6px 10px 0 rgba(0,0,0,.14), 0 1px 18px 0 rgba(0,0,0,.12), 0 3px 5px -1px rgba(0,0,0,.2);
    .tip {
      color: rgba(0,0,0,.54);
      font-size: 14px;
    }
    .date {
      margin-bottom: 20px;
      .date-title {
        color: rgba(0,0,0,.54);
        margin-bottom: 5px;
        font-size: 14px;
      }
    }
    .input {
      display: flex;
      align-items: flex-start;
      .left-title {
        width: 220px;
        color: #212121;
      }
      .right-content {
        width: calc(100% - 220px);
        position: relative;
        .select-type {
          display: flex;
          margin-bottom: 16px;
          .right-body {
            color: #5f6368;
            padding: 0 20px;
            .title {
              font-weight: bold;
              font-size: 15px;
              margin-bottom: 16px;
            }
            .content, .desc {
              font-size: 12px;
              margin-bottom: 16px;
            }
          }
        }
        .right-data-font {
          height: 80px;
          font-size: 13px;
          color: #5f6368;
          position: absolute;
          bottom: 0;
          right: 0;
          padding-left: 16px;
          border-left: 1px solid #dadce0;
          div {
            margin-bottom: 8px;
          }
        }
      }
    }
    .one-line {
      color: #212121;
      .title {
        color: #757575;
      }
    }
    .layer-items-content {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .layer-items {
        width: 220px;
        height: 156px;
        padding: 8px;
        border: 2px solid #dadce0;
        margin: 8px 0;
        text-align: center;
        font-size: 13px;
        cursor: pointer;
        .title {
          margin-top: 5px;
        }
        .title, .desc {
          color: #3C4043;
        }
        .layer-icon {
          width: 40px;
          height: 40px;
          margin-left: calc(50% - 20px);
          margin-top: 40px;
          border-radius: 50%;
          background: #369;
          display: flex;
          justify-content: center;
          align-items: center;
          i {
            color: #fff;
            font-size: 24px;
          }
        }
        .layer-title {
          margin-top: 10px;
          font-size: 13px;
          color: #222;
        }
      }
      .layer-items:hover {
        border: 2px solid #1A73E8;
        .layer-title {
          color: #1A73E8;
        }
      }
      .select-item {
        border: 2px solid #1A73E8;
        .layer-title {
          color: #1A73E8;
        }
      }
    }

    .checkbox {
      .check-item {
        margin-top: 8px;
      }
    }
  }

  .step-layer {
    width: 100%;
    background: #fff;
    height: 70px;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.12), 0 1px 5px 0 rgba(0,0,0,.2);
    display: flex;
    align-items: center;
    position: fixed;
    top: 66px;
    background: #fff;
    z-index: 2;
    .step {
      margin-left: 30px;
      display: flex;
      align-items: center;
      .step-item {
        display: flex;
        align-items: center;
        font-size: 14px;
        .step-icon {
          width: 28px;
          height: 28px;
          text-align: center;
          line-height: 28px;
          color: #fff;
          background: #616161;
          border-radius: 50%;
          font-size: 12px;
          margin-right: 8px;
        }
      }
      .step-line {
        width: 50px;
        height: 1px;
        background: #BDBDBD;
        margin: 0 8px;
      }
      .current {
        .step-icon {
          background: #4285F4;
        }
      }
    }
  }
</style>
